"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * See what keys have changed between two objects.
 *
 * Used primarily right now to compare what props have changed for
 * a react component.
 *
 * @param {Object} o1
 * @param {Object} o2
 *
 * @returns {Array}
 */
var changedKeys = function changedKeys() {
  var o1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var o2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var o1Keys = Object.keys(o1);
  var o2Keys = Object.keys(o2);
  var keys = [];
  o1Keys.forEach(function (key) {
    if (keys.indexOf(key) === -1) keys.push(key);
  });
  o2Keys.forEach(function (key) {
    if (keys.indexOf(key) === -1) keys.push(key);
  });
  return keys.filter(function (key) {
    return o1[key] !== o2[key];
  });
};
var _default = exports["default"] = changedKeys;